import { Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { Environment } from '~/types/EnvironmentTypes'
import { buildEnvironment, getApiEnvironment } from '~/utils/common'

import { toNounCasing } from '@mangovoice/core'

import { useEnvironmentLabelStyle } from './componentStyles'

export const EnvironmentLabel = () => {
  if (buildEnvironment === Environment.PRODUCTION) {
    return null
  }

  const styles = useEnvironmentLabelStyle()

  return (
    <Flex sx={styles.container}>
      <Text sx={styles.text}>
        {toNounCasing(getApiEnvironment())} API Environment
      </Text>
    </Flex>
  )
}
